import src from "IMAGE";
export default { src, width: 150, height: 33, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/webp;base64,UklGRnwAAABXRUJQVlA4THAAAAAvB0AAEM1VICICHgiAAAAAAACAIAQgAAAAAAAEAAAACAAAAAAAAABAABAAAAABwgAOAQAAgAgPBEAAAAAA4PwBMIIgiAAAgYAAAAAAAAAAAAAAAAAAAAAAAAAAIAEmQFKCOkUL0bU+YHzzucnsDpYH"};
